var _defs, _path, _path2, _path3, _circle, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgELogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 492 492",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e14f62;}.cls-2,.cls-3{fill:#fff;}.cls-3{opacity:0.14;}.cls-4{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M246,486A240,240,0,0,1,76.29,76.29,240,240,0,0,1,415.71,415.71,238.43,238.43,0,0,1,246,486Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246,12a234.07,234.07,0,0,1,91.08,449.62A234.07,234.07,0,0,1,154.92,30.38,232.66,232.66,0,0,1,246,12m0-12C110.14,0,0,110.14,0,246S110.14,492,246,492,492,381.86,492,246,381.86,0,246,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M387,281.37l-103.58-47c16.1-13.63,32.8-36.67,45.63-65,23.72-52.31,25.21-102.76,3.33-112.68s-58.84,24.44-82.56,76.75c-12.83,28.3-19.16,56-18.8,77.13L126.5,163.27a25,25,0,0,0-33.09,12.44h0a25,25,0,0,0,12.44,33.09l105.38,47.79C194.61,270,177.17,293.66,163.89,323c-23.72,52.31-25.21,102.76-3.33,112.68s58.85-24.44,82.57-76.75c13.28-29.3,19.59-58,18.73-79.35l104.47,47.37a25,25,0,0,0,33.09-12.44h0A25,25,0,0,0,387,281.37Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 391.5,
    cy: 338.5,
    r: 28
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M267.1,200.67a49.52,49.52,0,0,0-69.81,41.41,28,28,0,1,0,0,7,49.5,49.5,0,0,0,98.85-1.28h92.07v-1c0-77-72.5-139.5-146.5-139.5-80.5,0-148,72-148,155.5s70,155.5,153,155.5c53,0,101-27.5,127.5-58l-3.5-3.5c-26,30-72.5,56.5-124,56.5-80.5,0-148-69.5-148-150.5,0-5,.5-10,1-15l.5-5c9.5-72,70-130.5,141.5-130.5,69.5,0,139,58,141.5,130.5H296.07A49.47,49.47,0,0,0,267.1,200.67Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgELogo);
export default __webpack_public_path__ + "static/media/e_logo.66ad8d70843d63dbc8989792b1c4d84d.svg";
export { ForwardRef as ReactComponent };